//
//
//
//
//
//
//
//
//
//
//
//

import {
  cloneDeep,
  isEqual,
  omitBy,
  pick,
  pickBy,
  renameKey,
  uniq,
} from '@/utils/lodash'
import {
  isDynamicVariableString,
  isObject,
  isString,
  isUndef,
} from '@/utils/validator'
import {
  getDynamicVariableKey,
  getObjectDiffKeys,
  hasOwn,
  set,
} from '@/utils/util'
import { isEvent } from '@/_utils'
import { hyphenate } from '@/utils/transform'
import * as validatorClass from '@/utils/validatorClass'
import { normalizeDynamicDataByMobile } from '../../utils/util'
import CItem from '../CItem'
import { getPrefix } from '../../constant/baseComponentConfig'
import { post } from '../../utils/http'
import { toast } from '../../utils/toast'

const ITEM_PROPS = [...Object.keys(CItem.props)]

export default {
  name: 'CForm',

  components: { CItem },

  props: {
    model: {
      type: Object,
      default: () => ({}),
    },

    renderData: {
      type: Array,
      default: () => ([]),
    },

    divider: {
      type: Boolean,
      default: true,
    },

    postMethod: { type: Function },

    methodConfig: {
      type: Object,
      default: () => ({}),
    },

    dom: {
      type: String,
      default: '.base-info-write',
    },
  },

  data () {
    return {
      filteredRenderData: [],
      innerRenderData: [],
      dynamicVariable: {},
    }
  },

  computed: {
    bindKeys () {
      const arr = this.filteredRenderData.reduce((sum, v, i) => {
        sum.push(v.value)

        return sum
      }, [])

      return arr
    },

    dynamicVariableKeys () {
      return Object.keys(this.dynamicVariable)
    },

    itemClass () {
      return this.divider ? 'divider' : ''
    },
  },

  watch: {
    model: {
      immediate: true,
      deep: true,
      handler (v) {
        const validModel = this.getValidModel(this.model)

        if (!isEqual(validModel, this.localModel)) {
          const modifiedKeys = this.getModifiedKeys(validModel)

          this.localModel = cloneDeep(validModel)

          if (modifiedKeys.length) {
            this.updateValueByModifiedKeys(modifiedKeys)
          }
        }

        if (this.dynamicVariableKeys && this.dynamicVariableKeys.includes(this.previousModifiedKey)) {
          this.updateDynamicVariable([this.previousModifiedKey])
        }

        this.previousModifiedKey = ''
      },
    },

    renderData: {
      immediate: true,
      handler (renderData) {
        this.filteredRenderData = renderData.filter(({ none }) => !none) || []

        if (!isEqual(this.filteredRenderData, this.previousRenderData)) {
          this.previousRenderData = cloneDeep(this.filteredRenderData)
          this.innerRenderData = this.normalizeRenderData(this.filteredRenderData)
          this.dynamicVariable = this.getDynamicVariable()
        }
      },
    },
  },

  methods: {
    updateDynamicVariable (modifiedKeys = []) {
      for (let index = 0; index < modifiedKeys.length; index++) {
        const key = modifiedKeys[index]

        for (let i = 0; i < this.dynamicVariable[key].length; i++) {
          const index = this.dynamicVariable[key][i]
          let item = this.filteredRenderData[index]
          item = cloneDeep(item)

          const componentProps = this.getComponentProps(item)
          this.innerRenderData[index].componentProps = componentProps
        }
      }
    },

    updateValueByModifiedKeys (modifiedKeys) {
      this.innerRenderData.forEach((item) => {
        if (modifiedKeys.includes(item.valueName)) {
          item.value = cloneDeep(this.model[item.valueName])
        }
      })
    },

    getValidModel (model) {
      let validModel = {}

      if (this.bindKeys.length) {
        validModel = pick(model, this.bindKeys)
      } else {
        validModel = model
      }

      return validModel
    },

    getModifiedKeys (newValue) {
      // const diff = objectDiff.diff(this.localModel, newValue)
      const modifiedKeys = getObjectDiffKeys(this.localModel, newValue, [
        'change',
        'add',
        'remove',
      ])

      return modifiedKeys
    },

    getDynamicVariable () {
      /**
       */
      const dynamicVariable = {}

      this.filteredRenderData.forEach((v, i) => {
        this.collectDynamicVariable(v, i, dynamicVariable)
      })

      for (const key in dynamicVariable) {
        if (dynamicVariable.hasOwnProperty(key)) {
          dynamicVariable[key] = uniq(dynamicVariable[key])
        }
      }

      return dynamicVariable
    },

    collectDynamicVariable (data = {}, index, collectObj = {}) {
      data = data || {}

      for (const key in data) {
        if (data.hasOwnProperty && data.hasOwnProperty(key)) {
          const value = data[key]

          if (isDynamicVariableString(value)) {
            const variableKey = getDynamicVariableKey(value)

            if (!collectObj[variableKey]) {
              collectObj[variableKey] = []
            }

            collectObj[variableKey].push(index)
          } else if (isObject(value) || Array.isArray(value)) {
            this.collectDynamicVariable(value, index, collectObj)
          }
        }
      }
    },

    broadcastClear (clear) {
      this.broadcast('CItem', 'on-clear', [clear])
    },

    normalizeRenderData (renderData) {
      const result = renderData.map((item) => {
        return this.normalizeRenderDataItem(item)
      })

      return result
    },

    normalizeRenderDataItem (item) {
      const { component } = item
      item = cloneDeep(item)
      item.component = component

      item = this.getItemConfig(item)

      return item
    },

    getItemConfig (item) {
      const { placeholder } = item

      /**
       * 如果是表单的话，默认加上used: 1代表需要查询的数据都要是可用的。
       * 如果是查询区则不用加，查询区需要能查出来所有的数据
       *
       * tip: 这里组件如果是需要调用后端接口，而接口需要额外的参数都是会声明params这样的props, 这是约定，所以在这里统一改可以减少工作量。
       */
      if (isUndef(placeholder)) {
        const { component } = item

        const label = getPrefix(component)

        item.placeholder = `${label}`
      }

      if (this.isForm) {
        if (item.used === undefined) {
          if (!item.params) {
            item.params = {}
          }

          item.params.used = 1
        }
      }

      const componentProps = this.getComponentProps(item)
      const componentEvents = this.getComponentEvents(item)
      const itemProps = this.getItemProps(item)

      itemProps.componentProps = componentProps
      itemProps.componentEvents = componentEvents

      // 字段名
      itemProps.valueName = item.value

      // value值
      itemProps.value = cloneDeep(this.model[item.value])

      return itemProps
    },

    getComponentProps (item) {
      let componentProps = omitBy(item, (value, key) => {
        return ITEM_PROPS.includes(key) || !hasOwn(item, key) || key.indexOf('_') === 0
      })

      // 改名子是方便直接通过v-bind绑定。
      renameKey(componentProps, 'component', 'is')

      componentProps = normalizeDynamicDataByMobile(componentProps, this.model, this.postMethod || post)

      // const componentProps = normalizeDynamicData(item, this.model, this.postMethod || post)
      componentProps.methodConfig = this.methodConfig
      componentProps.postMethod = this.postMethod
      componentProps.dom = this.dom

      return componentProps
    },

    getItemProps (item) {
      const itemProps = pickBy(item, (value, key) => {
        return ITEM_PROPS.includes(key)
      })

      // 处理['MaxLength', 100]这样写法的规则，更简单
      itemProps.rules = itemProps.rules || []

      for (let index = 0; index < itemProps.rules.length; index++) {
        const el = itemProps.rules[index]

        if (Array.isArray(el)) {
          const [
            validator,
            ...args
          ] = el

          if (isString(validator) && validatorClass[validator]) {
            const rule = new validatorClass[validator](item.label, ...args)

            itemProps.rules.splice(index, 1, rule)
          }
        }
      }

      return itemProps
    },

    getComponentEvents (item) {
      const eventObj = {}

      Object.entries(item)
        .filter(([
          key,
          value,
        ]) => isEvent(key, value))
        .forEach(([
          key,
          value,
        ]) => {
          eventObj[hyphenate(key.slice(1))] = value
        })

      return eventObj
    },

    handleInput (v, item) {
      item.value = v

      if (isEqual(this.model[item.valueName], v)) {
        return
      }

      set(this.model, item.valueName, v)
      this.localModel[item.valueName] = v // localModel不是也不需要是响应式数据
      this.previousModifiedKey = item.valueName
    },

    async validate () {
      let valid = true
      const validateList = this.getValidateList()

      for (let i = 0; i < validateList.length; i++) {
        const validateItem = validateList[i]
        const error = await validateItem.validate('force')

        if (error) {
          valid = false

          // validateItem.$el.scrollIntoView({ behavior: 'smooth' })
          toast(error)

          return valid
        }
      }

      return valid
    },

    getValidateList () {
      this.$nextTick()
      const result = this.$children.filter((el) => {
        if (el.$options.name === 'CItem') {
          return el
        }
      }) || []

      return result
    },

    broadcast (componentName, eventName, params) {
      this.$children.forEach((child) => {
        const name = child.$options.name

        if (name === componentName) {
          child.$emit.apply(child, [eventName].concat(params))
        } else {
          // todo 如果 params 是空数组，接收到的会是 undefined
          this.broadcast.apply(child, [
            componentName,
            eventName,
          ].concat([params]))
        }
      })
    },
  },
}
